import { Box, Button, Flex, HStack, Image, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBrand } from '../branding/useBrand';
import { useAuth } from '../auth/AuthProvider';
import { UserMenu } from './UserMenu';
import { CreditsBadge } from './CreditsBadge';

export function PublicHeader({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  const brand = useBrand();
  const { authenticated } = useAuth();

  return (
    <Box as="header" px={6} py={compact ? 3 : 6}>
      <Flex maxW="1200px" mx="auto" align="center" justify="space-between" gap={4}>
        <Link to="/generator">
          <HStack spacing={3}>
            <Image src={brand.logoSrc} alt={brand.name} h={compact ? '32px' : '40px'} />
            <Text
              fontSize={compact ? 'md' : 'lg'}
              fontWeight={700}
              color="whiteAlpha.900"
              display={{ base: 'none', sm: 'inline' }}
            >
              {brand.name}
            </Text>
          </HStack>
        </Link>
        <HStack spacing={2}>
          {authenticated && (
            <>
              <CreditsBadge />
              <Button as={Link} to="/favourites" data-cta="nav:favourites" size="sm" variant="ghost" color="whiteAlpha.900" _hover={{ bg: 'whiteAlpha.200' }}>
                {t('nav.favourites', 'Favourites')}
              </Button>
              <UserMenu />
            </>
          )}
          {!authenticated && (
            <>
              <Button as={Link} to="/login" data-cta="auth:sign-in" size="sm" variant="ghost" color="whiteAlpha.900" _hover={{ bg: 'whiteAlpha.200' }}>
                {t('nav.signIn')}
              </Button>
              <Button as={Link} to="/register" data-cta="auth:sign-up" size="sm" variant="solid">
                {t('nav.signUp')}
              </Button>
            </>
          )}
        </HStack>
      </Flex>
    </Box>
  );
}
